(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["m-star-features"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.starCycleInit) return;
    root.dataset.starCycleInit = '1';

    var items = root.querySelectorAll('.m-star-features__item');
    if (items.length < 2) return;

    var ms = parseInt(root.dataset.mStarCycleMs, 10) || 2000;
    var i = 0;
    var mq = window.matchMedia('(max-width: 699px)');
    var timer = null;

    function setActive(n) {
      for (var k = 0; k < items.length; k++) items[k].classList.remove('is-active');
      items[n].classList.add('is-active');
    }

    function tick() {
      i = (i + 1) % items.length;
      setActive(i);
    }

    function start() {
      stop();
      if (!mq.matches) return;
      setActive(i);
      timer = setInterval(tick, ms);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    start();
    if (mq.addEventListener) mq.addEventListener('change', start);
    else mq.addListener(start);
  }

  document.querySelectorAll('.m-star-features').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.m-star-features');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-stories-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.m-stories').forEach(function (root) {
  var track = root.querySelector('.m-stories__track');
  var prev = root.querySelector('.m-stories__arrow--prev');
  var next = root.querySelector('.m-stories__arrow--next');
  if (!track) return;

  function step() {
    var slide = track.querySelector('.m-stories__slide');
    var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
    return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
  }

  // Show prev only when scrolled past start; hide next at the end (is-gone fade).
  function sync() {
    var max = track.scrollWidth - track.clientWidth;
    if (prev) prev.classList.toggle('is-gone', track.scrollLeft <= 1);
    if (next) next.classList.toggle('is-gone', track.scrollLeft >= max - 1);
  }

  // Vertically centre the arrow on the IMAGE (square media), like the homepage.
  function placeArrow() {
    var media = root.querySelector('.m-article-card__media');
    if (!media) return;
    var h = media.getBoundingClientRect().height;
    if (h > 0) root.style.setProperty('--m-stories-arrow-top', (h / 2) + 'px');
  }

  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', function () { sync(); placeArrow(); });
  window.addEventListener('load', function () { sync(); placeArrow(); });
  sync();
  placeArrow();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-visit-studio"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ORDER = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  function toMin(s) {
    var m = /^\s*(\d{1,2}):(\d{2})\s*$/.exec(s || '');
    return m ? (+m[1]) * 60 + (+m[2]) : null;
  }
  function fmt(min) {
    var h = Math.floor(min / 60), m = min % 60, ap = h >= 12 ? 'pm' : 'am', hh = h % 12 || 12;
    return m ? hh + ':' + String(m).padStart(2, '0') + ap : hh + ap;
  }
  function update(el) {
    var hours;
    try { hours = JSON.parse(el.getAttribute('data-visit-hours')); } catch (e) { return; }
    function day(name) {
      var d = hours[name]; if (!d) return null;
      var o = toMin(d.open), c = toMin(d.close);
      return (o == null || c == null) ? null : { open: o, close: c };
    }
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'long', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (o) { p[o.type] = o.value; });
    var todayName = p.weekday.toLowerCase(), todayIdx = ORDER.indexOf(todayName), now = (+p.hour) * 60 + (+p.minute);
    var t = day(todayName), text, open = false;
    if (t && now >= t.open && now < t.close) { text = 'Open now until ' + fmt(t.close); open = true; }
    else if (t && now < t.open) { text = 'Closed now — open from ' + fmt(t.open); }
    else {
      for (var i = 1; i <= 7; i++) {
        var nd = ORDER[(todayIdx + i) % 7], dd = day(nd);
        if (dd) { text = 'Closed now — open from ' + fmt(dd.open) + (i === 1 ? ' tomorrow' : ' on ' + nd.charAt(0).toUpperCase() + nd.slice(1)); break; }
      }
    }
    if (!text) return;
    var span = el.querySelector('.m-visit-studio__status-text');
    if (span) span.textContent = text;
    el.classList.toggle('is-open', open);
    el.classList.toggle('is-closed', !open);
  }
  function run() { document.querySelectorAll('.m-visit-studio__eyebrow[data-visit-status]').forEach(update); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setInterval(run, 60000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-diamond"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(section) {
      var modal = section.querySelector('[data-pdpd-modal]');
      var open = section.querySelector('[data-pdpd-open]');
      if (!modal || !open || modal.dataset.bound) return;
      modal.dataset.bound = '1';

      var frame = modal.querySelector('[data-src]');
      open.addEventListener('click', function () {
        if (frame && !frame.src) frame.src = frame.dataset.src;
        if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
      });

      modal.querySelectorAll('[data-pdpd-close]').forEach(function (b) {
        b.addEventListener('click', function () { modal.close ? modal.close() : modal.removeAttribute('open'); });
      });

      /* Clicking the backdrop lands on the dialog itself, not its contents. */
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.close ? modal.close() : modal.removeAttribute('open');
      });
    }

    /* Loupe360 renders at the size named in the url, so ask for the size we show.
       Rounded to 50px, otherwise every resize tick would reload the viewer. */
    function sizeFrame(frame) {
      var box = frame.getBoundingClientRect();
      var css = Math.round(Math.max(box.width, box.height));
      if (!css) return;
      var px = Math.min(1200, Math.max(200, Math.round(css / 50) * 50));
      /* The viewer renders at a multiple of 50, so it rarely equals the box.
         Left alone it sits top-left and the card's background shows as a
         hairline down the right and bottom edges. Give the frame the render's
         own size and scale it to the box so it fills exactly. */
      frame.style.width = px + 'px';
      frame.style.height = px + 'px';
      frame.style.transformOrigin = 'top left';
      frame.style.transform = 'scale(' + css / px + ')';
      if (frame.dataset.px === String(px)) return;
      frame.dataset.px = px;
      frame.src = 'https://loupe360.com/diamond/' + frame.dataset.loupe +
        '/video/' + px + '/' + px + '/autoplay?type=360';
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('[data-pdpd-frame]').forEach(sizeFrame);
      }, 250);
    });

    /* Fade the placeholder once the media loads. Images that never load keep it,
       which beats a broken-image glyph. Listeners attach before sizeFrame sets
       the iframe src, so the load event cannot be missed. */
    function watchMedia(box) {
      if (box.dataset.watched) return;
      box.dataset.watched = '1';
      var media = box.querySelector('.pdpd__frame, .pdpd__img');
      var wait = box.querySelector('.media-wait');
      if (!wait) return;
      if (!media) { box.classList.add('is-loaded'); return; }
      var done = function () { box.classList.add('is-loaded'); };
      if (media.tagName === 'IMG' && media.complete && media.naturalWidth) done();
      else media.addEventListener('load', done);
    }

    function init() {
      document.querySelectorAll('.pdpd').forEach(bind);
      document.querySelectorAll('[data-pdpd-media]').forEach(watchMedia);
      document.querySelectorAll('[data-pdpd-frame]').forEach(sizeFrame);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
